import { AuthError } from '@juvare/platform-app/App';
export function protectHiddenFileAccess(file) {
    if (file.data.hidden) {
        throw new AuthError('Unauthorized. Cannot modify hidden file');
    }
}
